export default __webpack_public_path__ + "static/media/passport.0ee7b4b4.svg";